export const getRand = (min, max) => Math.floor(Math.random() * (max - min) + min);